<div class="public-layout" [class.public-layout--client]="isClientRoute">
  <div class="gradient-background">
    <app-navigation></app-navigation>
  </div>

  <div class="public-content-wrapper">
    <router-outlet></router-outlet>
    <app-join-section></app-join-section>
    <app-footer-section></app-footer-section>
  </div>
</div>

